<template>
	<div id="app">
		<!-- 头部导航 -->
		<el-header v-if="isLoggedIn" class="app-header">
			<div class="header-content">
				<div class="logo">
					<img src="@/assets/images/webwxgetmsgimg.jpg" alt="数海领航" class="logo-image" />
					<span class="logo-text">数海领航邮件群发系统</span>
				</div>
				
				<!-- 移动端菜单按钮 -->
				<el-button
					v-if="isMobile"
					type="text"
					icon="el-icon-menu"
					class="mobile-menu-btn"
					@click="toggleSidebar"
				></el-button>
				
				<div class="header-actions">
					<el-dropdown trigger="click">
						<span class="user-info">
							<i class="el-icon-user"></i>
							<span class="username">{{ currentUser.phone || currentUser.username }}</span>
							<i class="el-icon-arrow-down"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
													<el-dropdown-item @click.native="$router.push('/set-password')">
							<i class="el-icon-lock"></i>
							设置密码
						</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">
							<i class="el-icon-switch-button"></i>
							退出登录
						</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</el-header>

		<div v-if="isLoggedIn" class="app-container">
			<!-- 侧边栏 -->
			<el-aside
				:class="['app-sidebar', { 'sidebar-collapse': isMobile && !sidebarVisible }]"
				:width="sidebarWidth"
			>
				<!-- 移动端遮罩 -->
				<div
					v-if="isMobile && sidebarVisible"
					class="sidebar-overlay"
					@click="toggleSidebar"
				></div>
				
				<el-menu
					:default-active="$route.path"
					router
					background-color="#304156"
					text-color="#bfcbd9"
					active-text-color="#409EFF"
					class="sidebar-menu"
				>
				<el-submenu index="/products">
					<template slot="title">
						<i class="el-icon-s-grid"></i>
						<span>产品介绍</span>
					</template>
					<el-menu-item index="/products/enterprise-screening"><i class="el-icon-search"></i> 企业信息筛查系统</el-menu-item>
					<el-menu-item index="/products/global-acquisition"><i class="el-icon-guide"></i> 全球获客系统</el-menu-item>
					<el-menu-item index="/products/promotion"><i class="el-icon-share"></i> 推广系统</el-menu-item>
					<el-menu-item index="/products/advanced-mailer"><i class="el-icon-message"></i> 高级版邮箱群发系统</el-menu-item>
				</el-submenu>
					<el-menu-item index="/usage-guide">
						<i class="el-icon-document"></i>
						<span slot="title">使用说明</span>
					</el-menu-item>
					<el-menu-item index="/dashboard">
						<i class="el-icon-odometer"></i>
						<span slot="title">仪表板</span>
					</el-menu-item>
					<el-menu-item index="/email-configs">
						<i class="el-icon-setting"></i>
						<span slot="title">邮箱配置</span>
					</el-menu-item>
					<el-menu-item index="/recipients">
						<i class="el-icon-user"></i>
						<span slot="title">收件人管理</span>
					</el-menu-item>
					<el-menu-item index="/send-email">
						<i class="el-icon-message"></i>
						<span slot="title">发送邮件</span>
					</el-menu-item>
					<el-menu-item index="/send-logs">
						<i class="el-icon-document"></i>
						<span slot="title">发送记录</span>
					</el-menu-item>
					<el-menu-item index="/contact">
						<i class="el-icon-phone"></i>
						<span slot="title">联系我们</span>
					</el-menu-item>
				</el-menu>
			</el-aside>

			<!-- 主内容区 -->
			<el-main class="app-main">
				<router-view />
			</el-main>
		</div>

		<!-- 未登录状态显示路由内容（直接渲染以支持全屏宣传页） -->
		<div v-else>
			<router-view />
		</div>
		
		<!-- 广告弹窗组件 -->
		<AdvertisementPopup v-if="isLoggedIn" />
	</div>
</template>

<script>
import AdvertisementPopup from '@/components/AdvertisementPopup.vue'

export default {
	name: 'App',
	components: {
		AdvertisementPopup
	},
	data() {
		return {
			sidebarVisible: false,
			windowWidth: window.innerWidth
		}
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		currentUser() {
			return this.$store.state.user || {};
		},
		isMobile() {
			return this.windowWidth < 768;
		},
		sidebarWidth() {
			if (this.isMobile) {
				return this.sidebarVisible ? '200px' : '0px';
			}
			return '200px';
		}
	},
	mounted() {
		// 监听窗口大小变化
		window.addEventListener('resize', this.handleResize);
		
		// 设置axios默认token
		if (this.isLoggedIn) {
			const token = this.$store.getters.userToken;
			if (token) {
				this.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			}
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		logout() {
			this.$store.dispatch('logout');
			this.$router.push('/login');
			this.$message.success('已退出登录');
		},
		
		toggleSidebar() {
			this.sidebarVisible = !this.sidebarVisible;
		},
		
		handleResize() {
			this.windowWidth = window.innerWidth;
			// 在桌面端自动显示侧边栏
			if (!this.isMobile) {
				this.sidebarVisible = false;
			}
		}
	}
}
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

#app {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100vh;
	display: flex;
	flex-direction: column;
}

.app-header {
	background: #fff;
	border-bottom: 1px solid #e6e6e6;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	z-index: 1000;
	position: relative;
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	padding: 0 20px;
}

.logo {
	display: flex;
	align-items: center;
	font-size: 20px;
	font-weight: bold;
	color: #303133;
}

.logo i {
	font-size: 24px;
	color: #409EFF;
	margin-right: 8px;
}

.logo-text {
	display: inline-block;
}

.logo-image {
	width: 32px;
	height: 32px;
	margin-right: 12px;
	border-radius: 6px;
	object-fit: cover;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.mobile-menu-btn {
	display: none;
}

.header-actions {
	display: flex;
	align-items: center;
}

.user-info {
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 0 12px;
	color: #606266;
	transition: color 0.3s;
}

.user-info:hover {
	color: #409EFF;
}

.user-info i {
	margin: 0 4px;
}

.username {
	margin: 0 8px;
}

.app-container {
	display: flex;
	flex: 1;
	overflow: hidden;
}

.app-sidebar {
	background: #304156;
	transition: all 0.3s;
	position: relative;
	z-index: 1001;
}

.sidebar-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
}

.sidebar-collapse {
	margin-left: -200px;
}

.sidebar-menu {
	border: none;
	height: 100%;
	overflow-y: auto;
}

.sidebar-menu .el-menu-item {
	padding-left: 20px !important;
}

.app-main {
	flex: 1;
	background: #f0f2f5;
	overflow-y: auto;
	padding: 20px;
}

.login-container {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
	.header-content {
		padding: 0 15px;
	}
	
	.logo-text {
		display: none;
	}
	
	.mobile-menu-btn {
		display: block;
	}
	
	.app-sidebar {
		position: fixed;
		top: 60px;
		left: 0;
		bottom: 0;
		z-index: 1001;
	}
	
	.app-main {
		padding: 15px;
		margin-left: 0;
	}
	
	.username {
		display: none;
	}
}

@media (max-width: 480px) {
	.app-main {
		padding: 10px;
	}
	
	.header-content {
		padding: 0 10px;
	}
}

/* Element UI 响应式优化 */
.el-table {
	font-size: 14px;
}

@media (max-width: 768px) {
	.el-table {
		font-size: 12px;
	}
	
	.el-table .el-table__cell {
		padding: 8px 0;
	}
	
	.el-dialog {
		width: 95% !important;
		margin: 0 auto;
	}
	
	.el-form .el-form-item__label {
		width: 80px !important;
	}
	
	.el-button--small {
		padding: 7px 10px;
		font-size: 12px;
	}
}
</style> 